/* The two strips and the day-rows viewport stack into one attached unit, with
   no gap between them so they share single-line dividers. */
.column {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
}

/* Chrome shared by whatever caps the day column: the week-navigation buttons
   at rest, the status line and action bar while selecting. */
.strip {
	background: var(--surface-card);
	border: 1px solid var(--border);
	/* Fixed height, and horizontal padding only: the week buttons and their
	   select-mode replacements must measure the same, or the viewport
	   resizes and every row shifts when the two swap. */
	height: 46px;
	padding: 0 var(--space-3);
	box-sizing: border-box;
	display: flex;
	align-items: center;
	gap: var(--space-3);
	font-size: 0.875rem;
}

/* Top strip caps the unit: rounds the top corners and drops its bottom border
   so the viewport's top border is the only divider between them. */
.stripTop {
	border-bottom: none;
	border-radius: var(--radius-md) var(--radius-md) 0 0;
}

/* Bottom strip mirrors it: rounds the bottom corners, no top border. */
.stripBottom {
	border-top: none;
	border-radius: 0 0 var(--radius-md) var(--radius-md);
}

.nav {
	font: inherit;
	font-size: 0.875rem;
	color: var(--ink-muted);
	cursor: pointer;
	justify-content: center;
	transition:
		background 120ms ease,
		color 120ms ease;
}

.nav:hover:not(:disabled) {
	color: var(--ink);
	background: var(--surface-input);
}

.nav:disabled {
	opacity: 0.6;
	cursor: default;
}

/* The viewport is a size container — child rows size themselves as a fraction
   of its height (12.5cqh = 1/8) so all 8 visible rows fit whatever vertical
   space the flex layout grants. The animation distances are derived the same
   way (87.5cqh = 7 rows). */
.viewport {
	flex: 1;
	min-height: 0;
	max-height: calc(8 * 84px);
	position: relative;
	/* `overflow: visible` at rest so recipe-suggestion dropdowns inside a
	   row can extend below the row. We only need to clip during the slide
	   animation, when 15 rows render but only 8 should be visible. */
	overflow: visible;
	container-type: size;
	background: var(--surface-card);
	/* Square — sandwiched between the two strips, which own the rounded
	   outer corners. Top/bottom borders are the dividers against each. */
	border: 1px solid var(--border);
	border-radius: 0;
}

.viewport:has(.slidingNext, .slidingPrev) {
	overflow: hidden;
}

/* Given an explicit height, nothing flexes: the viewport takes that height
   and the whole unit sits at its own size inside a parent — a dialog — with
   no vertical space of its own to divide up. */
.fixed,
.fixed .viewport {
	flex: none;
}

.fixed .viewport {
	height: var(--day-column-height);
}

.days {
	display: flex;
	flex-direction: column;
}

.slidingNext {
	animation: slideNext 320ms ease forwards;
}

.slidingPrev {
	animation: slidePrev 320ms ease forwards;
}

@keyframes slideNext {
	from {
		transform: translateY(0);
	}
	to {
		transform: translateY(-87.5cqh);
	}
}

@keyframes slidePrev {
	from {
		transform: translateY(-87.5cqh);
	}
	to {
		transform: translateY(0);
	}
}
